export const LIKEABLE_TYPE_COMPANY = 'Company';
export const LIKEABLE_TYPE_JOB = 'Job';
